import React from "react";
import { Progress } from "antd";
import { GraduationCap, BookOpen, Clock, Calendar, Award, Users, LucideCircleCheck } from "lucide-react";

export default function SelectCourseCard({
  title,
  subtitle,
  level,
  category,
  duration,
  startDate,
  instructor,
  enrolled,
  capacity,
  index,
  selected,
  onClick,
}) {
  const percent = Math.round((enrolled / capacity) * 100);
  const spotsLeft = capacity - enrolled;

   const progressColor = index % 2 === 0
  ? { from: "#10b981", to: "#06b6d4" }  
  : { from: "#facc15", to: "#f97316" }; 



  return (
    <div
      onClick={onClick}
      className={`rounded-xl border-2 transition-all shadow-sm group cursor-pointer overflow-hidden ${
        selected
          ? "border-purple-500 bg-gradient-to-br from-purple-50 to-indigo-50"
          : "border-slate-200 hover:border-purple-300 bg-white hover:shadow-xl"
      }`}
    >
      <div className="p-5 bg-transparent">
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-2 mb-2">
            <div
              className={`p-2 rounded-lg transition-colors ${
                selected
                  ? "bg-purple-500"
                  : "bg-slate-200 group-hover:bg-purple-100"
              }`}
            >
              <GraduationCap
                size={16}
                className={`transition-colors ${
                  selected ? "text-white" : "text-slate-600 group-hover:text-purple-600"
                }`}
              />
            </div>
            <h4 className="font-semibold text-[16px]">{title}</h4>
          </div>
          <span
            className={`text-[11px] inline-block mt-2 status-indicator ${level
              .toLowerCase()
              .replace(/\s+/g, "-")}`}
          >
            {level}
          </span>
        </div>

        <p className="text-[13px] text-gray-500 mb-4">{subtitle}</p>

        <div className="grid grid-cols-2 gap-3 mb-4">
          <div className="flex items-center gap-2 p-2 rounded-lg bg-slate-50">
            <BookOpen size={16} className="text-purple-600" />
            <div>
              <p className="text-[10px] text-gray-500">Category</p>
              <p className="text-[12px] font-semibold">{category}</p>
            </div>
          </div>

          <div className="flex items-center gap-2 p-2 rounded-lg bg-slate-50">
            <Clock size={16} className="text-blue-600" />
            <div>
              <p className="text-[10px] text-gray-500">Duration</p>
              <p className="text-[12px] font-semibold">{duration}</p>
            </div>
          </div>

          <div className="flex items-center gap-2 p-2 rounded-lg bg-slate-50">
            <Calendar size={16} className="text-emerald-600" />
            <div>
              <p className="text-[10px] text-gray-500">Starts</p>
              <p className="text-[12px] font-semibold">{startDate}</p>
            </div>
          </div>

          <div className="flex items-center gap-2 p-2 rounded-lg bg-slate-50">
            <Award size={16} className="text-amber-600" />
            <div>
              <p className="text-[10px] text-gray-500">Instructor</p>
              <p className="text-[12px] font-semibold truncate">{instructor}</p>
            </div>
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between text-[12px]">
            <span className="text-gray-500 flex items-center gap-1">
              <Users size={12} /> Enrollment
            </span>
            <span className="font-semibold">
              {enrolled}/{capacity}
            </span>
          </div>
          <Progress percent={percent} showInfo={false} strokeColor={progressColor} />
          <p className="text-[11px] text-gray-500">{spotsLeft} spots remaining</p>
        </div>

        {selected && (
          <div className="w-full mt-4 flex items-center justify-center gap-2 bg-gradient-to-r from-purple-500 to-indigo-500 border-0 p-2 rounded-xl font-semibold text-white">
            <LucideCircleCheck size={16} />
            <span className="flex gap-2 text-[13px] ">
               Course Selected
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
